import React, { type PropsWithChildren, useCallback, useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

export const RovoAnnouncementSplashSuppressor = ({ children }: PropsWithChildren<unknown>) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const [isVisible, setIsVisible] = React.useState(true);

	const handleVisibilityChange = useCallback(
		(modalOnScreen: boolean) => {
			const shouldShow = !modalOnScreen;

			if (!shouldShow) {
				createAnalyticsEvent({
					type: 'sendOperationalEvent',
					data: {
						action: 'suppressed',
						actionSubject: 'createWithRovoAnnouncementSplashModal',
						source: 'createWithRovoAnnouncementSplashModal',
					},
				}).fire();
			}

			setIsVisible(shouldShow);
		},
		[createAnalyticsEvent],
	);

	useEffect(() => {
		const modalOnScreen = !!globalThis.document.querySelector(
			'.atlaskit-portal-container .atlaskit-portal [role=dialog]',
		);

		handleVisibilityChange(modalOnScreen);
	}, [handleVisibilityChange]);

	return <>{isVisible && children}</>;
};
